import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";
import { getErrorMessage } from "#/utils/APIUtils";

const baseUrl = "/api/sif/zivalRazvojniStadij";

export const fetchDevelopmentStages = createAsyncThunk(
  "development-stage/list",
  async (_, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.get(baseUrl);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const fetchDevelopmentStageBySifra = createAsyncThunk(
  "development-stage/byCode",
  async (sifra, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.get(`${baseUrl}/${sifra}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

const developmentStageSlice = createSlice({
  name: "developmentStage",
  initialState: {
    page: null,
    list: [],
    byId: {},
    error: null,
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDevelopmentStages.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;

        action.payload.forEach((item) => {
          state.byId[item.sifra] = item;
        });
      })
      .addCase(fetchDevelopmentStages.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchDevelopmentStages.pending, (state, _) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchDevelopmentStageBySifra.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchDevelopmentStageBySifra.fulfilled, (state, action) => {
        state.isLoading = false;
        const item = action.payload;
        if (item?.sifra) {
          state.byId[item.sifra] = item;
          state.details = item.sifra;
        }
      })
      .addCase(fetchDevelopmentStageBySifra.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default developmentStageSlice.reducer;

export const SHEEP_GOAT_AGE_GROUP_CODE_LIST = createSelector(
  (state) => state.developmentStage.list,
  (list) => {
    return list?.filter((item) => item.veljaZaOvce || item.veljaZaKoze);
  }
);
